import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What do I need to get started with my custom software",
    answer: `<p>
      We do not expect our clients to be tech-nerd or IT geeks.
      All you need is a set of clearly defined goals and
      objectives behind your software development project. In our
      detailed consultation session, our consultants will help you
      identify your pain points, create an estimated development
      budget, and build a software development roadmap to add
      clarity for both stakeholders and development teams.
    </p>`,
  },
  {
    question: " What makes TekRevol the best custom software development",
    answer: `<p>
      Our UX-focused development approach and attention to detail
      make us stand out from the competition. We are an
      innovation-driven app development company in NJ, helping
      SMBs and enterprises become future-ready with our fail-proof
      development frameworks.
    </p>`,
  },
  {
    question: "How much does it cost to develop custom software?",
    answer: `<p>
      Determining the cost of custom software development isn't
      that simple. There are multiple parameters that need to be
      measured according to the overall requirements of the
      projects. Meanwhile, the requirements and scale of the
      project may vary according to different clients. Considering
      the market average, the estimated cost of a custom
      application starts from $90,000 and goes up to $200,000.
    </p>`,
  },
  {
    question:
      " Do you provide product support services after the software development is complete?",
    answer: ` <p>Yes. TekRevol is a full-scale software development company offering cross-platform and native app development services in NJ. We use Swift and Objective C for native <Link to="/iphone-app-development">iOS app development</Link>, Java or Kotlin for native <Link to="/android-app-development">Android app development</Link>, and Flutter or React Native for cross-platform app development for both iOS and Android. Book your free consultation session to discuss development frameworks for your app in detail.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
